import { AxiosError } from 'axios';
import { createAsyncAction } from 'typesafe-actions';
import { Task, TaskComment, TaskCommentParams, TaskParams } from './types';

export const GET_TASK_LIST = 'tasks/GET_TASK_LIST';
export const GET_TASK_LIST_SUCCESS = 'tasks/GET_TASK_LIST_SUCCESS';
export const GET_TASK_LIST_ERROR = 'tasks/GET_TASK_LIST_ERROR';

export const CREATE_TASK = 'tasks/CREATE_TASK';
export const CREATE_TASK_SUCCESS = 'tasks/CREATE_TASK_SUCCESS';
export const CREATE_TASK_ERROR = 'tasks/CREATE_TASK_ERROR';

export const UPDATE_TASK = 'tasks/UPDATE_TASK';
export const UPDATE_TASK_SUCCESS = 'tasks/UPDATE_TASK_SUCCESS';
export const UPDATE_TASK_ERROR = 'tasks/UPDATE_TASK_ERROR';

export const DELETE_TASK = 'tasks/DELETE_TASK';
export const DELETE_TASK_SUCCESS = 'tasks/DELETE_TASK_SUCCESS';
export const DELETE_TASK_ERROR = 'tasks/DELETE_TASK_ERROR';

export const GET_TASK_DETAIL = 'tasks/GET_TASK_DETAIL';
export const GET_TASK_DETAIL_SUCCESS = 'tasks/GET_TASK_DETAIL_SUCCESS';
export const GET_TASK_DETAIL_ERROR = 'tasks/GET_TASK_DETAIL_ERROR';

export const CREATE_TASK_COMMENT = 'tasks/CREATE_TASK_COMMENT';
export const CREATE_TASK_COMMENT_SUCCESS = 'tasks/CREATE_TASK_COMMENT_SUCCESS';
export const CREATE_TASK_COMMENT_ERROR = 'tasks/CREATE_TASK_COMMENT_ERROR';

export const CHANGE_STATUS_TASK = 'tasks/CHANGE_STATUS_TASK';
export const CHANGE_STATUS_TASK_SUCCESS = 'tasks/CHANGE_STATUS_TASK_SUCCESS';
export const CHANGE_STATUS_TASK_ERROR = 'tasks/CHANGE_STATUS_TASK_ERROR';

export const getTaskListAsync = createAsyncAction(
  GET_TASK_LIST,
  GET_TASK_LIST_SUCCESS,
  GET_TASK_LIST_ERROR,
)<TaskParams, Task[], AxiosError>();

export const createTaskAsync = createAsyncAction(
  CREATE_TASK,
  CREATE_TASK_SUCCESS,
  CREATE_TASK_ERROR,
)<TaskParams, Task, AxiosError>();

export const updateTaskAsync = createAsyncAction(
  UPDATE_TASK,
  UPDATE_TASK_SUCCESS,
  UPDATE_TASK_ERROR,
)<TaskParams, Task, AxiosError>();

export const deleteTaskAsync = createAsyncAction(
  DELETE_TASK,
  DELETE_TASK_SUCCESS,
  DELETE_TASK_ERROR,
)<TaskParams, number, AxiosError>();

export const getTaskDetailAsync = createAsyncAction(
  GET_TASK_DETAIL,
  GET_TASK_DETAIL_SUCCESS,
  GET_TASK_DETAIL_ERROR,
)<TaskParams, Task, AxiosError>();

export const createTaskCommentAsync = createAsyncAction(
  CREATE_TASK_COMMENT,
  CREATE_TASK_COMMENT_SUCCESS,
  CREATE_TASK_COMMENT_ERROR,
)<TaskCommentParams, TaskComment, AxiosError>();

export const changeStatusTaskAsync = createAsyncAction(
  CHANGE_STATUS_TASK,
  CHANGE_STATUS_TASK_SUCCESS,
  CHANGE_STATUS_TASK_ERROR,
)<TaskParams, Task, AxiosError>();
